import { Injectable } from '@angular/core';

import { UserContextService } from 'app/core/services/user-context.service';
import { map, Observable, take } from 'rxjs';

import { PhoneNumberUpdateService } from 'app/core/services/phone-number-update.service';
import { EmployeeProfileService } from '@core/services';

@Injectable({ providedIn: 'root' })
export class AccountManagementService {
  mfaPhone$: Observable<string>;
  accountName$ = this.userContextService.userContext$.pipe(
    map(userContext => userContext.userName)
  );

  accountEmail$ = this.employeeProfileService.userMail$.pipe(map(personal => personal.email));

  constructor(
    private userContextService: UserContextService,
    private phoneNumberUpdateService: PhoneNumberUpdateService,
    private employeeProfileService: EmployeeProfileService
  ) {}

  getMfaPhoneNumber(): Observable<string> {
    return (this.mfaPhone$ = this.phoneNumberUpdateService.getMFAPhoneNumber().pipe(
      take(1),
      map(mfaPhone => mfaPhone.PhoneNumber)
    ));
  }
}
